<!--***
  --- FORM GROUP ---
  ***-->

<div *ngFor="let row of inputForm" class="flex flex-col lg:flex-row"
  [formGroup]="formGroup">
  <div *ngFor="let column of row" class="w-full px-[10px]">
    <ng-container *ngIf="sectionAllowed(column.visibleForSection)">
      <ng-container
        *ngIf="!column.isHidden"
        [ngTemplateOutlet]="selectTemplate(column.template!)"
        [ngTemplateOutletContext]="{ form: formGroup, item: column }">
      </ng-container>
    </ng-container>
  </div>
</div>

<!--***
  **
  *
  --- TEMPLATE INPUT ---
  *
  **
  ***-->

<!--INPUT-->
<ng-template #input let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full">
    <mat-form-field [appearance]="appearance" class="width100Full">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>
      <div class="input">
        <input [type]="item.inputType ? item.inputType : 'null'"
          [formControlName]="item.formControlName" matInput
          [placeholder]="utils.traslatei18n(item?.placeholder || item.label)" [value]="item.value"
          [maxlength]="item.maxlength ? item.maxlength : null"
          [minlength]="item.minlength ? item.minlength : null"
          [required]="form.controls[item.formControlName].errors?.required" />

        <mat-icon *ngIf="item.info" class="classInfo"
          [matTooltip]="item.info">info</mat-icon>
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #searchInput let-item="item" let-form="form">
  <div [formGroup]="form"
    class="width100Full flex flex-col h-full items-center justify-center">

    <div
      class="flex flex-row justify-between  light-background theme-color rounded-full py-2 px-4 w-full">

      <mat-icon class="material-icons-outlined mr-3">
        search
      </mat-icon>
      <input class="w-full bg-transparent"
        [type]="item.inputType ? item.inputType : 'null'"
        [formControlName]="item.formControlName" matInput
        [placeholder]="item?.placeholder" [value]="item.value"
        [required]="form.controls[item.formControlName].errors?.required" />
    </div>
  </div>
</ng-template>

<!--inputPercent-->
<ng-template #inputPercent let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full">
    <mat-form-field [appearance]="appearance" class="width100Full">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>
      <div class="input">
        <input [type]="item.inputType ? item.inputType : 'null'"
          [formControlName]="item.formControlName" matInput
          [placeholder]="item?.placeholder" [value]="item.value"
          [required]="form.controls[item.formControlName].errors?.required" />
        <span matSuffix>%</span>

        <mat-icon *ngIf="item.info" class="classInfo"
          [matTooltip]="item.info">info</mat-icon>
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>

<!--TEXTAREA-->
<ng-template #textarea let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full">
    <mat-form-field [appearance]="appearance" class="width100Full">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>

      <div class="input">
        <textarea [formControlName]="item.formControlName" matInput
          [placeholder]="item?.placeholder"
          [value]="item.value"
          [required]="form.controls[item.formControlName].errors?.required"></textarea>
        <mat-icon *ngIf="item.info" class="classInfo"
          [matTooltip]="item.info">info</mat-icon>
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>

<!--DATAPICKER-->
<ng-template #dataPicker let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full" (click)="picker.open()">
    <mat-form-field [appearance]="appearance" class="width100Full">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>

      <div class="input">
        <input readonly matInput [min]="item.minDate" [max]="item.maxDate"
          [formControlName]="item.formControlName"
          [matDatepicker]="picker"
          [placeholder]="utils.traslatei18n(item.placeholder)"
          [required]="form.controls[item.formControlName].errors?.required" />

        <mat-icon *ngIf="item.info" class="classInfoDataPicker"
          [matTooltip]="item.info">info</mat-icon>
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>

      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </div>
</ng-template>

<!--SELECT-->
<ng-template #select let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full">
    <mat-form-field [appearance]="appearance" class="width100Full">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>
      <div class="input">
        <mat-select
          [required]="form.controls[item.formControlName].errors?.required"
          [formControlName]="item.formControlName"
          [multiple]="item.isMultipleSelect"
          [attr.data-test-serenity-select]="item.formControlName">
          <mat-option *ngFor="let element of item.objectSelect"
            [value]="element" [attr.data-test-serenity-option]="element">
            <div class="row">
              <div>{{ element }}</div>
            </div>
          </mat-option>
        </mat-select>

        <mat-icon *ngIf="item.info" class="classInfo"
          [matTooltip]="item.info">info</mat-icon>
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>

<!--SELECTOBJECT-->
<ng-template #selectObject let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full">
    <mat-form-field [appearance]="appearance" class="width100Full">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>
      <div class="input">
        <mat-select [attr.data-test-serenity-select]="item.formControlName"
          [required]="form.controls[item.formControlName].errors?.required"
          [formControlName]="item.formControlName"
          [multiple]="item.isMultipleSelect">
          <mat-option *ngFor="let element of item.objectSelect"
            [value]="element[item.keySelect]"
            [attr.data-test-serenity-option]="element[item.keySelect]">
            <div class="row">
              <div>{{ utils.traslatei18n(element[item.viewValueSelect]) }}</div>
            </div>
          </mat-option>
        </mat-select>

        <mat-icon *ngIf="item.info" class="classInfo"
          [matTooltip]="item.info">info</mat-icon>
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>
<!--SELECTGROUP-->
<ng-template #selectGroup let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full">
    <mat-form-field [appearance]="appearance" class="width100Full"
      color="accent">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>
      <div class="input">
        <mat-select
          [required]="form.controls[item.formControlName].errors?.required"
          [formControlName]="item.formControlName"
          [multiple]="item.isMultipleSelect"
          [attr.data-test-serenity-select]="item.formControlName">
          <mat-optgroup *ngFor="let group of item.objectSelect"
            [label]="group[item.nameGroupSelect]">
            <mat-option *ngFor="let element of group[item.keyGroupSelect]"
              [value]="element[item.keySelect]"
              [attr.data-test-serenity-option]="element[item.keySelect]">
              {{ element[item.viewValueSelect] }}
            </mat-option>
          </mat-optgroup>
        </mat-select>

        <mat-icon *ngIf="item.info" class="classInfo"
          [matTooltip]="item.info">info</mat-icon>
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>

<!--CHECKBOX-->
<ng-template #checkBox let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full check">
    <div class="input">
      <mat-checkbox [formControlName]="item.formControlName"
        [attr.data-test-serenity-checkbox]="item.formControlName">
        <div class="checkbox">
          <div>
            {{ utils.traslatei18n(item.label) }}
          </div>
          <div
            *ngIf="item.validators.required && !form.controls[item.formControlName].value"
            style="margin-left: 4px">
            *
          </div>
        </div>
      </mat-checkbox>

      <mat-icon *ngIf="item.info" class="classInfo"
        [matTooltip]="item.info">info</mat-icon>
    </div>
    <div
      *ngIf="!(item.validators.required && form.controls[item.formControlName].value === false)"
      style="height: 20px"></div>
    <div
      *ngIf="item.validators.required && form.controls[item.formControlName].value === false"
      class="checkbox-error"
      [class.show]="!form.controls[item.formControlName].value">
      {{ utils.traslatei18n("requiredField") }}
    </div>
  </div>
</ng-template>

<!-- AUTOCOMPLETEWithButton-->
<ng-template #autocompleteWithButton let-item="item" let-form="form">
  <div [formGroup]="form" class="md:w-full w-[300px]">
    <mat-form-field [appearance]="appearance" class="width100Full"
      color="accent">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>
      <div class="input">
        <mat-select #sl
          [required]="form.controls[item.formControlName].errors?.required"
          color="accent" class="z-10"
          (openedChange)="closePannelSelect($event, item)"
          [formControlName]="item.formControlName"
          [multiple]="item.isMultipleSelect"
          [attr.data-test-serenity-select]="item.formControlName">
          <div class="w-full p-2 flex flex-col justify-between items-center">
            <div class="w-full flex items-center">
              <mat-form-field class="w-full" appearance="outline">
                <mat-label>{{ utils.traslatei18n("Search") }}</mat-label>
                <input matInput
                  [formControl]="formGroupAutocomplete.controls[item.formControlName]" />
                <mat-icon matSuffix class="classInfo">search</mat-icon>
              </mat-form-field>
            </div>
            <div class="flex flex-row justify-between w-full">
              <div *ngIf="item.isMultipleSelect"
                class="p-2 w-full flex flex-row text-center justify-center -mt-4 cursor-pointer"
                matRipple
                (click)="setAll(item)">
                <div>{{ utils.traslatei18n("Select all") }}</div>
              </div>
              <div
                class="p-2 bg-red-500/20 w-full flex flex-row text-center justify-center -mt-4 cursor-pointer"
                matRipple (click)="clearAll(item)">
                <div>{{ utils.traslatei18n("Clear") }}</div>
              </div>
            </div>
          </div>
          <div class="max-h-64 overflow-auto pb-6">
            <mat-option *ngFor="let element of item.objectSelect"
              [value]="element[item.keySelect]"
              [attr.data-test-serenity-option]="element[item.keySelect]">
              <div class="flex flex-row items-center">
                <!-- <mat-icon *ngIf="item.info" matPrefix [matTooltip]="utils.traslatei18n(element[item.info] ? element[item.info] : element,
                item.fatherKeyTraslate)">info</mat-icon> -->
                <div>
                  {{
                  utils.traslatei18n(
                  element[item.viewValueSelect] ? element[item.viewValueSelect]
                  : element,
                  item.fatherKeyTraslate
                  )
                  }}
                </div>
              </div>
            </mat-option>
          </div>
          <div
            class="p-2 bg-[#223e80] w-full text-white flex flex-row text-center justify-center -mt-4 cursor-pointer"
            matRipple (click)="applyAutocomplate(item); sl.close()">
            <div>{{ utils.traslatei18n("apply") }}</div>
          </div>
        </mat-select>

        <!-- <mat-icon *ngIf="item.info" class="classInfo" [matTooltip]="item.info">info</mat-icon> -->
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>

<!-- AUTOCOMPLETE-->
<ng-template #autocomplete let-item="item" let-form="form">
  <div [formGroup]="form" class="w-full">
    <mat-form-field [appearance]="appearance" class="w-full" color="accent">
      <mat-label>{{ utils.traslatei18n(item.label) }} </mat-label>
      <div class="input">
        <mat-select
          class=" "
          disableOptionCentering
          [required]="form.controls[item.formControlName].errors?.required"
          color="accent"
          (openedChange)="closePannelSelect($event, item)"
          [formControlName]="item.formControlName"
          [attr.data-test-serenity-select]="item.formControlName"
          [multiple]="item.isMultipleSelect">
          <mat-select-trigger>{{ getAutocompleteDisplayValue(item, form.controls[item.formControlName].value) }}</mat-select-trigger>
          <mat-option *ngIf="item.lazyLoad" disabled class="lazy-load-sentinel"></mat-option>
          <div>
            <div class="w-full p-2 flex flex-col justify-between items-center">
              <div class="w-full flex items-center">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-icon matSuffix>search</mat-icon>
                  <mat-label>{{ utils.traslatei18n("Search") }}</mat-label>
                  <input matInput (keydown)="$event.stopPropagation()"
                    [formControl]="formGroupAutocomplete.controls[item.formControlName]" />

                </mat-form-field>
              </div>
              <div class="flex flex-row justify-between w-full">
                <div *ngIf="item.isMultipleSelect"
                  class="p-2 w-full flex flex-row text-center justify-center -mt-4 cursor-pointer"
                  matRipple
                  (click)="setAll(item)">
                  <div>{{ utils.traslatei18n("Select all") }}</div>
                </div>
                <div
                  class="p-2 bg-red-500/20 w-full flex flex-row text-center justify-center -mt-4 cursor-pointer"
                  matRipple (click)="clearAll(item)">
                  <div>{{ utils.traslatei18n("Clear") }}</div>
                </div>
              </div>
            </div>

            <div class="max-h-72 overflow-auto autocomplete-lazy-panel">
              <!-- Singolo contenitore per overflow -->
              <cdk-virtual-scroll-viewport *ngIf="!item.lazyLoad || item.objectSelect?.length"
                itemSize="48" style="height: 200px;"
                dir="ltr" minBufferPx="200" maxBufferPx="600"
                (scrolledIndexChange)="onAutocompleteScroll($event, item)">
                <mat-option *cdkVirtualFor="let element of item.objectSelect"
                  [value]="element[item.keySelect]" class="ltr"
                  [disabled]="element.disabled"
                  (onSelectionChange)="selectElementAutocomplete($event, item)"
                  [attr.data-test-serenity-option]="element[item.keySelect]">
                  <div class="flex flex-row items-center">
                    <div class>
                      {{
                      utils.traslatei18n(
                      element[item.viewValueSelect] ?
                      element[item.viewValueSelect] : element,
                      item.fatherKeyTraslate
                      )
                      }}
                    </div>
                  </div>
                </mat-option>
              </cdk-virtual-scroll-viewport>
              <mat-option *ngIf="item.lazyLoad && item.loading"
                disabled
                class="lazy-load-status-option"
                data-test-serenity-lazy-loader>
                <div class="lazy-load-status" aria-live="polite">
                  <mat-spinner [diameter]="18"></mat-spinner>
                  <span>{{ utils.traslatei18n("LOADING") }}</span>
                </div>
              </mat-option>
              <mat-option *ngIf="item.lazyLoad && !item.loading && (!item.objectSelect || item.objectSelect.length === 0)"
                disabled
                class="lazy-load-status-option"
                data-test-serenity-lazy-empty>
                <div class="lazy-load-status empty">
                  {{ utils.traslatei18n("notElementFound") }}
                </div>
              </mat-option>
            </div>
          </div>
        </mat-select>

        <!-- <mat-icon *ngIf="item.info" class="classInfo" [matTooltip]="item.info">info</mat-icon> -->
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>

<ng-template #autocompleteGroup let-item="item" let-form="form">
  <div [formGroup]="form" class="width100Full">
    <mat-form-field [appearance]="appearance" class="width100Full">
      <mat-label>{{ utils.traslatei18n(item.label) }}</mat-label>
      <div class="input">
        <mat-select
          [required]="form.controls[item.formControlName].errors?.required"
          (openedChange)="closePannelSelect($event, item)"
          [formControlName]="item.formControlName"
          [multiple]="item.isMultipleSelect"
          [attr.data-test-serenity-select]="item.formControlName">
          <div class="w-full p-2 flex flex-col justify-between items-center">
            <div class="w-full flex items-center">
              <mat-form-field class="w-full" appearance="outline">
                <mat-label>{{ utils.traslatei18n("Search") }}</mat-label>
                <input matInput
                  [formControl]="formGroupAutocomplete.controls[item.formControlName]" />
                <mat-icon matSuffix class="classInfo">search</mat-icon>
              </mat-form-field>
            </div>
            <div class="flex flex-row justify-between w-full">
              <div *ngIf="item.isMultipleSelect"
                class="p-2 w-full flex flex-row text-center justify-center -mt-4 cursor-pointer"
                matRipple
                (click)="setAll(item)">
                <div>{{ utils.traslatei18n("Select all") }}</div>
              </div>
              <div
                class="p-2 bg-red-500/20 w-full flex flex-row text-center justify-center -mt-4 cursor-pointer"
                matRipple (click)="clearAll(item)">
                <div>{{ utils.traslatei18n("Clear") }}</div>
              </div>
            </div>
          </div>
          <div class="max-h-72 overflow-auto">
            <mat-optgroup *ngFor="let group of item.objectSelect"
              [label]="utils.traslatei18n(group.title)"
              [disabled]="group.disabled">
              <mat-option *ngFor="let element of group.value"
                [value]="element[item.keySelect]"
                (onSelectionChange)="selectElementAutocompleteGroup($event, item)"
                [attr.data-test-serenity-option]="element[item.keySelect]">
                <div class="row">
                  <div>
                    {{
                    utils.traslatei18n(
                    element[item.viewValueSelect]
                    ? element[item.viewValueSelect]
                    : element[item.viewValueSelect],
                    item.fatherKeyTraslate
                    )
                    }}
                  </div>
                </div>
              </mat-option>
            </mat-optgroup>
          </div>
        </mat-select>

        <mat-icon *ngIf="item.info" class="classInfo"
          [matTooltip]="item.info">info</mat-icon>
      </div>

      <mat-error *ngFor="let validator of objectKey(item.validators)">
        <ng-container [ngTemplateOutlet]="selectValidator(validator!)"
          [ngTemplateOutletContext]="{ form: form, item: item }">
        </ng-container>
      </mat-error>
    </mat-form-field>
  </div>
</ng-template>

<!--dataPickerOnlyYearAndMonth-->
<ng-template #dataPickerOnlyYearAndMonth let-item="item" let-form="form">
  <app-generate-datapicker-only-year-and-month-input [item]="item" [form]="form"
    [appearanceForm]="appearanceForm">
  </app-generate-datapicker-only-year-and-month-input>
</ng-template>

<ng-template #radioButtonList let-item="item" let-form="form">
  <div class="width100Full flex flex-col mb-2" [formGroup]="form">
    <mat-label class="text-[12px]  text-black/50">{{
      utils.traslatei18n(item.label) }}</mat-label>

    <mat-radio-group [formControlName]="item.formControlName"
      aria-label="Select an option "
      class="py-2 w-full justify-around flex flex-row">
      <div *ngFor="let item of item.objectSelect" class="px-2">
        <mat-radio-button [value]="item.value" class=" text-black">{{
          utils.traslatei18n(item.label)
          }}</mat-radio-button>
      </div>
    </mat-radio-group>
  </div>
</ng-template>

<!--***
  **
  *
  --  VALIDATOR MESSAGE --
  *
  **
  ***-->

<ng-template #emailValidator let-item="item" let-form="form">
  <mat-error *ngIf="form.controls[item.formControlName].hasError('email')">{{
    utils.traslatei18n("email_not_valid") }}
  </mat-error>
</ng-template>

<ng-template #requiredValidator let-item="item" let-form="form">
  <mat-error *ngIf="form.controls[item.formControlName].hasError('required')">{{
    utils.traslatei18n("requiredField") }}
  </mat-error>
</ng-template>

<ng-template #patternValidator let-item="item" let-form="form">
  <div style="display: flex; align-items: center">
    <mat-error
      *ngIf="form.controls[item.formControlName].hasError('pattern')">{{
      utils.traslatei18n("not_valid_value")
      }}
    </mat-error>
    <mat-icon
      *ngIf="form.controls[item.formControlName].hasError('pattern') && item.infoPattern"
      class="iconInfoError"
      [matTooltip]="item.infoPattern">{{ utils.traslatei18n("info")
      }}</mat-icon>
  </div>
</ng-template>
